import Raven from 'raven-js';

/**
 * Sends error to Sentry.
 */
function trackError(error: Error, options?: Raven.RavenOptions) {
  Raven.captureException(error, options);
}

/**
 * Enables global error handler by adding window.error event listener.
 */
export function enableGlobalErrorHandler() {
  function handleError(event: ErrorEvent) {
    event.error.hasBeenCaught = true;
    trackError(event.error);
    return true;
  }

  window.addEventListener('error', handleError);
}

export default { trackError };
